import React from 'react'

import store from '../../store/configureStore'
import accountUtils from '../../utils/account/accountUtils'

const onlyIfUnauthenticated = WrappedComponent => props => {
  const {
    currentUser: { user },
    insToken: { requestEnded: doneFetchingInsToken, insToken },
  } = store.getState()
  const { pathname } = props.location // eslint-disable-line

  // Check if the user exists
  const userExists = accountUtils.userExists(user)

  // User exists and they have not completed onboarding, and they are not on Onboarding page
  if (
    userExists &&
    !user.stripe_customer_id &&
    !user.insToken &&
    pathname !== '/onboarding' &&
    doneFetchingInsToken
  ) {
    props.history.push('/onboarding') // eslint-disable-line
    return null
  }

  // User exists and they have finished onboarding
  else if (userExists && (user.stripe_customer_id || insToken)) {
    switch (user.info.userType) {
      case 'admin':
        // If they're an admin, take them to admin dashboard
        props.history.push('/app/admin')
        break
      case 'parent':
        // If they're a parent, take them to the parent dashboard
        props.history.push('/app/parent')
        break
      default:
        props.history.push('/app/dashboard')
    }
    return null
  }

  // If the user doesn't exist, and they're on Onboarding, take them to login
  else if (!userExists && pathname === '/onboarding') {
    props.history.push('/login')
    return null
  }

  // Display their requested route
  return <WrappedComponent {...props} />
}

export default onlyIfUnauthenticated



// WEBPACK FOOTER //
// ./src/components/hocs/onlyIfUnauthenticated.js